module.exports = __webpack_public_path__ + "img/image19.201e320b.jpg";